import setModalVideo from "../../../frontend/js/video-modal";

function findElementWithVideoDataset(el) {
    while (!el.dataset.videoId && !el.parentElement.matches('body')) {
        el = el.parentElement;
    }
    return el.dataset.videoId ? el : null;
    
}


function startVideo(e) {
    const elem = findElementWithVideoDataset(e.target);
    if(!elem) return;
    const videoHost = elem.dataset.videoHost;
    const videoId = elem.dataset.videoId;
    e.stopPropagation();
    setModalVideo({videoHost, videoId});
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".cta-block__image-container--video").forEach((el) => {
        el.addEventListener("click", startVideo);
    });
});